export const TYPE = {
    compact: 'compact',
    compactSide: 'compactSide',
    uniformSide: 'uniformSide',
    uniformFull: 'uniformFull',
};
export const SIZE = {
    small: 'small',
    medium: 'medium',
};
export const ALIGNMENT = {
    start: 'start',
    center: 'center',
    end: 'end',
};
//# sourceMappingURL=Tabs.constants.js.map